import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { iconFor } from "./iconMap";

interface MenuLinkProps {
  title: string;
  toRoute: string;
  iconKey?: string;
  collapsed?: boolean;
  nested?: boolean;
}

export default function MenuLink({
  title,
  toRoute,
  iconKey,
  collapsed = false,
  nested = false,
}: MenuLinkProps) {
  const Icon = iconFor(iconKey || toRoute);

  const button = (
    <ListItemButton
      component={NavLink}
      to={toRoute}
      sx={{
        minHeight: 48,
        justifyContent: collapsed ? "center" : "flex-start",
        px: collapsed ? 2.5 : nested ? 4 : 2.5,
        color: "var(--gray-100)",
        "&.active": {
          backgroundColor: "var(--blue-400)",
          color: "var(--white)",
        },
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.08)",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: collapsed ? 0 : 2,
          justifyContent: "center",
          color: "inherit",
        }}
      >
        <Icon />
      </ListItemIcon>
      {!collapsed && (
        <ListItemText
          primary={title}
          slotProps={{ primary: { sx: { fontSize: 14 } } }}
        />
      )}
    </ListItemButton>
  );

  if (collapsed) {
    return (
      <Tooltip title={title} placement="right" arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
}
